// @ts-nocheck
import * as React from "react"
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import "swiper/css/pagination"

export default ({ data }: { data: SolutionSection }) => {
    const [refSwiper, setRefSwiper] = React.useState()

    React.useEffect(() => {
    }, [refSwiper])

    if (data.images.length < 2) return <img data-aos='fade-up' src={data.images[0].url} alt={data.images[0].alt} title={data.images[0].alt} />

    return (
        <Swiper
            modules={[Pagination]}
            spaceBetween={20}
            pagination={{
                "clickable": true
            }}
            breakpoints={{
                640: {
                    slidesPerView: 2
                },
                991: {
                    slidesPerView: 3
                },
                1199: {
                    slidesPerView: 4
                }
            }}
            id='imageCarousel'
            data-aos='fade-up'
        >
            {data.images.map((image: ESImage, indexImage: number) => (
                <SwiperSlide key={indexImage}>
                    <img src={image.url} alt={image.alt} title={image.alt} />
                </SwiperSlide>
            ))}
        </Swiper>
    )
}